module.exports = __webpack_public_path__ + "static/media/Alcohol.4a4353ee.svg";